import { createStore, createTypedHooks } from 'easy-peasy';
import { userExampleStore } from 'features/userExampleFeature/stores';
import { fileUploadStore } from 'features/files/stores/fileUploadStore';
import { modalManagerStore } from 'features/modalManager/stores/modalManagerStore';
import { urlStateStore } from 'features/urlState/stores/urlStateStore';
import { meStore } from './me';
import { classicLinkContextStore } from './classicLinkContext';
import type { GlobalStore } from './types';

// import and add feature stores to the global store
const globalStores: GlobalStore = {
  userExample: userExampleStore,
  fileUpload: fileUploadStore,
  modalManager: modalManagerStore,
  me: meStore,
  urlState: urlStateStore,
  classicLinkContext: classicLinkContextStore,
};

// Export typed hooks
export const typedHooks = createTypedHooks<GlobalStore>();
export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;

// Create and export store
export const globalStore = createStore<GlobalStore>(globalStores);
